import { Link } from 'react-router';

export function PaymentCancelPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col px-6 py-8">
      <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center">
        <div
          aria-hidden
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'var(--surface-2)',
            color: 'var(--fg-muted)',
            fontSize: 28,
            lineHeight: '56px',
            fontWeight: 700,
          }}
        >
          ←
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="text-xl font-semibold">Payment cancelled</h1>
          <p className="text-sm text-[color:var(--color-fg-muted)]">
            No charge was made. You can pick up where you left off whenever
            you're ready.
          </p>
        </div>
        <Link
          to="/profile"
          className="h-11 inline-flex items-center justify-center rounded-xl border border-[color:var(--color-border)] px-5 text-sm font-medium hover:border-[color:var(--color-fg-muted)]"
        >
          Back to my groups
        </Link>
      </div>
    </main>
  );
}
